export const layoutMessages = {
  'footer.col.about': '关于我们',
  'footer.col.help': '帮助中心',
  'footer.col.service': '平台服务',
  'footer.copy': '© 2024 跨地域电商平台 · 毕业设计项目 · 仅供学习交流',
  'footer.link.afterSale': '售后政策',
  'footer.link.allProducts': '全部商品',
  'footer.link.cart': '购物车',
  'footer.link.contact': '联系客服',
  'footer.link.intro': '平台介绍',
  'footer.link.shipping': '配送说明',
  'footer.logo': '✦ 跨地域电商平台',
  'footer.slogan': '让每一件商品跨越地域限制',
  'front.auth.login': '登录 / 注册',
  'front.auth.logout': '退出',
  'front.brand': '跨地域电商',
  'front.cart.loginHint': '登录后使用购物车',
  'front.cart.title': '购物车',
  'front.fav.loginHint': '登录后查看收藏',
  'front.fav.title': '我的收藏',
  'front.guest.hint': '游客 · 仅浏览',
  'front.lang.label': '语言',
  'front.nav.admin': '后台管理',
  'front.nav.home': '首页',
  'front.nav.products': '全部商品',
  'front.searchPlaceholder': '搜索商品、品类、品牌…',
  'front.notifications.title': '消息通知',
  'front.notifications.empty': '暂无消息',
  'front.notifications.viewAll': '查看全部',
  'front.user.levelDefault': '普通用户',
  'front.user.roleAdmin': '管理员',
  'front.user.roleUser': '用户',
  'layout.action.backFront': '返回前台',
  'layout.action.logout': '退出登录',
  'layout.brand.desc': '管理控制台',
  'layout.brand.name': '智能商品运营',
  'layout.user.fallback': '管理员',
  // 消息通知
  'notif.title': '消息通知',
  'notif.all': '全部',
  'notif.unread': '未读',
  'notif.empty': '暂无消息',
  'notif.markAllRead': '全部已读',
  'notif.justNow': '刚刚',
  'notif.typeOrder': '订单',
  'notif.typeSystem': '系统',
  'notif.typePromotion': '促销',
  'notif.orderShipped': '订单已发货',
  'notif.orderShippedDesc': '您的订单 #ORD20260503002 已发货，请留意查收',
  'notif.promotion': '限时优惠',
  'notif.promotionDesc': '生鲜水果夏季促销 — 低至7折！',
  'notif.system': '系统公告',
  'notif.systemDesc': '平台计划于5月10日凌晨2:00-4:00进行维护',
  'notif.orderDelivered': '订单已送达',
  'notif.orderDeliveredDesc': '您的订单 #ORD20260501001 已确认收货',
  'notif.reviewRemind': '评价提醒',
  'notif.reviewRemindDesc': '您购买的商品还未评价，分享您的使用体验吧',
};
